import React from "react";
import { NavLink } from "react-router-dom";
import Logo from "@/components/Logo";
import { LayoutDashboard, Users, Calendar, Video, UsersRound, MessageSquare, ClipboardList, ClipboardCheck, Home, School, BarChart3, BookOpen, Settings as Cog, Heart } from "lucide-react";

const ITEMS = [
  { to: "/dashboard", label: "Dashboard", Ic: LayoutDashboard },
  { to: "/patients", label: "Patients", Ic: Users },
  { to: "/schedule", label: "Schedule", Ic: Calendar },
  { to: "/telehealth", label: "Telehealth", Ic: Video },
  { to: "/care-team", label: "Care Team", Ic: UsersRound },
  { to: "/messages", label: "Messages", Ic: MessageSquare, badge: 3 },
  { to: "/assessments", label: "Assessments", Ic: ClipboardList },
  { to: "/treatment-plans", label: "Treatment Plans", Ic: ClipboardCheck },
  { to: "/parent-portal", label: "Parent Portal", Ic: Home },
  { to: "/school-iep", label: "School / IEP", Ic: School },
  { to: "/analytics", label: "Analytics", Ic: BarChart3 },
  { to: "/app-resources", label: "Resources", Ic: BookOpen },
  { to: "/settings", label: "Settings", Ic: Cog },
];

export default function Sidebar() {
  return (
    <aside className="hidden lg:flex flex-col w-[258px] shrink-0 h-screen sticky top-0 bg-white/90 backdrop-blur border-r border-slate-100">
      <div className="px-5 py-5 border-b border-slate-50"><Logo height={40} to="/dashboard" /></div>
      <nav className="flex-1 overflow-y-auto thin-scroll px-3 py-4 space-y-1">
        {ITEMS.map(({ to, label, Ic, badge }) => (
          <NavLink key={to} to={to} data-testid={`side-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className={({ isActive }) => `sidebar-item flex items-center gap-3 rounded-xl px-3.5 py-2.5 text-[15px] font-semibold ${isActive ? "sidebar-active" : "text-[#33425c]"}`}>
            {({ isActive }) => (<><Ic size={19} className={isActive ? "text-white" : "text-[#7488a8]"} /><span className="flex-1">{label}</span>{badge && <span className={`h-5 min-w-5 px-1 grid place-items-center rounded-full text-[11px] font-bold ${isActive ? "bg-white/25 text-white" : "bg-[#e23b3b] text-white"}`}>{badge}</span>}</>)}
          </NavLink>
        ))}
      </nav>
      <div className="px-5 py-5 border-t border-slate-50">
        <div className="font-hand text-[22px] text-[#1a5fd0] leading-tight flex items-center gap-2"><Heart size={16} className="fill-[#e23b3b] text-[#e23b3b]" /> Healthy Minds<br />Brighter Futures</div>
      </div>
    </aside>
  );
}
